import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

export const FormTypeLabel = styled.div`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #607890);
  margin-bottom: 0.25rem;
`

export const FormTypeName = styled.div`
  ${font('xs', 'bold')}
  color: var(--colour-text-primary, #222b33);
  margin-bottom: 0.75rem;
`

export const FormTypeCount = styled.div`
  ${font('xl', 'bold')}
  color: var(--colour-text-action, #4e56ea);
`

export const FormTypeCardContainer = styled.button<{ 'data-active'?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border: none;
  width: 200px;
  height: 96px;
  padding: 0.75rem 1rem;
  background-color: var(--colour-fill-neutral-lightest, #f2f4f6);
  border-radius: 0.5rem;
  cursor: pointer;
  text-align: left;

  &:focus,
  &:focus-visible {
    outline: 2px solid var(--colour-fill-action-dark, #4e56ea);
  }

  &:hover {
    background-color: #e5e9ed;
  }

  &[data-active='true'] {
    background-color: var(--colour-fill-action-dark, #4e56ea);

    & > * {
      color: white;
    }

    & > ${FormTypeLabel} {
      color: var(--colour-fill-action-lightest, #d6e1ff);
    }

    &:hover {
      background-color: var(--colour-fill-action-dark, #4844da);
    }
  }
`

export const TilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  row-gap: 1rem;
  margin-bottom: 1.5rem;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5rem;
`

export const CardsRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 1rem;
`

/** Row of lighter sub-type chips, shown under the family tiles once a family is selected. */
export const ChipsRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 0.5rem;
  row-gap: 0.5rem;
`

export const TypeChip = styled.button<{ 'data-active'?: boolean }>`
  ${font('xs', 'bold')}
  border: 1px solid var(--colour-border-neutral, #dde2e6);
  border-radius: 999px;
  padding: 0.375rem 0.875rem;
  background-color: var(--colour-fill-background, #ffffff);
  color: var(--colour-text-primary, #222b33);
  cursor: pointer;

  &:focus,
  &:focus-visible {
    outline: 2px solid var(--colour-fill-action-dark, #4e56ea);
  }

  &:hover {
    background-color: var(--colour-fill-neutral-lightest, #f2f4f6);
  }

  &[data-active='true'] {
    background-color: var(--colour-fill-action-dark, #4e56ea);
    border-color: var(--colour-fill-action-dark, #4e56ea);
    color: white;

    &:hover {
      background-color: var(--colour-fill-action-dark, #4844da);
    }
  }
`
